import { Box, styled, Typography } from '@mui/material';

export const CompanyInfoContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  width: '100%',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(3, 0, 6),
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2.5, 0, 5),
  },
}));

export const InfoCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
  borderRadius: theme.typography.pxToRem(12),
  padding: theme.spacing(2.5),
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minWidth: 0,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
}));

export const PanelSectionTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.overline,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2),
}));

export const SectionDivider = styled(Box)(({ theme }) => ({
  height: 1,
  backgroundColor: theme.palette.custom.OV.sys.outlineVariant,
}));
